import { ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import ListIcon from '@mui/icons-material/List';
import FolderOffOutlinedIcon from '@mui/icons-material/FolderOffOutlined';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import FolderList from "./FolderList";
import FolderListBase from "./FolderListBase";
import { useCreateFolderModal } from "../../store/modal-context";

const FolderNavigationList = () => {
    const createFolderModal = useCreateFolderModal();
    const shortcutItems = [
        { id: 'dashboard', title: "Tutti i file", link: "/dashboard", icon: <ListIcon /> },
        { id: 'no-folder', title: "Senza cartella", link: "/folder/noFolder", icon: <FolderOffOutlinedIcon /> }
    ];

    return (
        <Stack direction={'column'} spacing={2} mt={4}>
            <nav aria-label="folders">
                <Typography variant="body1" fontWeight={'bold'}>
                    Scorciatoie
                </Typography>
                <FolderListBase
                    items={shortcutItems}
                    getItemLink={(item) => item.link}
                />
                <Typography variant="body1" fontWeight={'bold'}>
                    Cartelle
                </Typography>
                <FolderList
                    getFolderLink={(item) => `/folder/${item.id}`}
                />
                <ListItem disablePadding>
                    <ListItemButton onClick={() => createFolderModal.openModal()}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>
                            <CreateNewFolderOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="Nuova Cartella"
                            sx={{
                                color: 'black',
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            </nav>
        </Stack>
    );
};

export default FolderNavigationList;
